"use strict";
/**
 * Shift Checklist Request Types
 *
 * Request DTOs for the shift checklist endpoints (matrix model, GH#454).
 *
 * @example POST  /api/shift-checklist/activities
 * @example GET   /api/shift-checklist/view
 * @example POST  /api/shift-checklist/record
 */
Object.defineProperty(exports, "__esModule", { value: true });
